class MorphContainerElement extends HTMLElement {
  #tr = null;

  connectedCallback() {
    addEventListener("click", this);
  }

  disconnectedCallback() {
    removeEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      if (e.composedPath().includes(this)) {
        const button = e.target.closest("button");
        if (button) {
          const { action } = button.dataset;
          if (action === "morph-toggle") {
            this.toggle();
          } else if (action === "morph-open") {
            this.toggle(true);
          } else if (action === "morph-close") {
            this.toggle(false);
          }
        }
      } else if (this.hasAttribute("open")) {
        this.toggle(false);
      }
    }
  }

  async toggle(force) {
    const prev = this.hasAttribute("open");
    const button = this.querySelector("button");
    const panel = this.querySelector(".morph-panel");

    const ro = panel.getBoundingClientRect();
    const rc = button.getBoundingClientRect();

    const t = `${rc.top - ro.top}px`;
    const r = `${rc.right - ro.left}px`;
    const b = `${rc.bottom - ro.top}px`;
    const l = `${rc.left - ro.left}px`;

    this.style.setProperty("--rect-btn", `${t} ${r} ${b} ${l}`);
    const open = this.toggleAttribute("open", force);
    if (open === prev) return;

    this.classList.add("transition");

    if (this.#tr)
      this.#tr.cancel();

    this.#tr = panel.animate(
      { clipPath: open
          ? ["var(--rect-min)", "var(--rect-max)"]
          : ["var(--rect-max)", "var(--rect-min)"] },
      { duration: 300, easing: "ease" },
    );

    try {
      await this.#tr.finished;
      this.classList.remove("transition");
    } catch {}
  }
}

customElements.define("morph-container", MorphContainerElement);
